// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__fdG9O","addWidgetButton":"Header_addWidgetButton__204Ad","dashboardTabs":"Header_dashboardTabs__1bqBq","active":"Header_active__2iSnO"};